var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocial3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_47"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "aqua",
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social",
    transform: "translate(0 0.203)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, -0.2)",
    filter: "url(#Ellipse_47)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47-2",
    "data-name": "Ellipse 47",
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter",
    "data-name": "Icon awesome-twitter",
    d: "M18.14,7.473c.013.18.013.359.013.539A11.709,11.709,0,0,1,6.363,19.8,11.71,11.71,0,0,1,0,17.942a8.572,8.572,0,0,0,1,.051,8.3,8.3,0,0,0,5.145-1.77,4.151,4.151,0,0,1-3.874-2.874,5.226,5.226,0,0,0,.783.064,4.383,4.383,0,0,0,1.09-.141A4.144,4.144,0,0,1,.821,9.205V9.154a4.173,4.173,0,0,0,1.873.526A4.15,4.15,0,0,1,1.411,4.138,11.779,11.779,0,0,0,9.955,8.474a4.678,4.678,0,0,1-.1-.949,4.148,4.148,0,0,1,7.172-2.835,8.158,8.158,0,0,0,2.63-1,4.133,4.133,0,0,1-1.822,2.284,8.307,8.307,0,0,0,2.386-.641A8.908,8.908,0,0,1,18.14,7.473Z",
    transform: "translate(10.891 9.409)",
    fill: "aqua"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial3);
export default __webpack_public_path__ + "static/media/social3.90209e10217fe41495b90c4696940155.svg";
export { ForwardRef as ReactComponent };